// @flow

import {Dom, Loc} from 'main.core';
import {Form} from './form';

export class FormLizingMainPage
{
	#app;
	constructor(rootNode): void
	{
		this.rootNode = document.querySelector(rootNode);
	}

	start(): void
	{
		this.attachTemplate();
	}
	attachTemplate(): void
	{
		const variant = this.rootNode && this.rootNode.dataset.formDesignVariant
			? this.rootNode.dataset.formDesignVariant
			: 'default';
		this.#app = BX.Vue3.BitrixVue.createApp({
			components: {
				Form
			},
			data()
			{
				return {variant};
			},
			template: `
				<div>
					<Form :variant="variant"/>
				</div>
				`
		});
		this.#app.mount(this.rootNode);
	}
}
